import { useQuery, UseQueryOptions } from 'react-query'
import { SUCCESS_RESPONSE_TYPE } from 'api/constants'
import { useCurrentArticleId } from 'hooks/useCurrentArticleId'
import { BlogMetadataRecord, BlogMetadataRecordsClient } from 'api/clients/BlogMetadataRecordsClient'
import { AIJobStatus } from 'types'
import { useModals } from 'almanac-ui/Modal'

type Data = BlogMetadataRecord

const BLOG_WIZARD_NAMES = ['BlogPostWizard', 'MinimalBlogPostWizard', 'MultiStepBlogPostWizard']

export const useBlogMetadataRecord = (options?: UseQueryOptions<Data>) => {
  const articleId = useCurrentArticleId() ?? ''
  const { stack } = useModals()

  const isBlogWizardOpen = stack.some(({ component }) => {
    const name = component.name || component.displayName || component.toString()
    return BLOG_WIZARD_NAMES.some((wizardName) => name.includes(wizardName))
  })

  return useQuery<Data>(
    ['blogMetadataRecord', articleId],
    async () => {
      const response = await BlogMetadataRecordsClient.get({ articleId })

      if (response.type !== SUCCESS_RESPONSE_TYPE) {
        throw new Error('An error occurred fetching metadata! Our team has been notified and we are looking into it.')
      }

      return response.data
    },
    {
      enabled: !!articleId && !isBlogWizardOpen && options?.enabled !== false,
      refetchInterval: (data) => {
        if (!data) return false

        const isJobComplete =
          data.status !== undefined &&
          [AIJobStatus.Successful, AIJobStatus.Failed, AIJobStatus.Expired].includes(data.status)

        if (isJobComplete) {
          return false
        }

        return 500
      },
      refetchIntervalInBackground: true,
      ...options,
    },
  )
}
